import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledFillGapsPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .lines {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: ${Colors.backgroundPaleBlueDark};
    padding: 20px 30px 30px;
    border-radius: 20px;

    .text-with-gaps {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 2px 10px;
      margin-top: 20px;
      .gap {
        min-width: 100px;
        min-height: 50px;
        border: 1px solid ${Colors.lightGray}33;
        background-color: white;
        border-radius: 12px;
        box-shadow: inset -1px 1px 1px 0px ${Colors.lighterGray};

        .incorrect-answer {
          text-decoration: line-through;
          text-decoration-color: ${Colors.red};
        }

        .correct-answer {
          text-align: center;
          position: absolute;
          left: 0;
          bottom: -70%;
          color: ${Colors.green};
        }
      }
      .over .gap {
        background-color: ${Colors.lighterGray}66;
      }
      .over .option.dropped {
        background-color: ${Colors.lighterGray}aa;
      }
      .feedback {
        position: absolute;
        top: -50%;
        right: -50%;
        .feedback-icon {
          font-size: 100%;
        }
      }
    }
  }

  .options {
    margin-top: 50px;
    display: flex;
    gap: 32px;
  }

  @media only screen and (max-height: 500px) and (orientation: landscape) {
    .lines {
      margin-top: 10px;
      padding: 12px 20px 16px;
      border-radius: 12px;
      .text-with-gaps {
        margin: -4px 0;
        line-height: 0.6;
        .gap {
          min-width: 80px;
          min-height: 36px;
          line-height: 1.2;
          .correct-answer {
            bottom: -80%;
          }
        }
      }
    }
    .options {
      margin-top: 24px;
    }
  }
`;
